/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WidgetMediaResponse = {
    /**
     * File name in the storage bucket
     */
    filename?: string;
    /**
     * Public CDN URL
     */
    cdnUrl?: string;
    /**
     * Full path in the storage bucket
     */
    fullPath?: string;
    /**
     * Media type: image or video
     */
    type?: WidgetMediaResponse.type;
};
export namespace WidgetMediaResponse {
    /**
     * Media type: image or video
     */
    export enum type {
        IMAGE = 'image',
        VIDEO = 'video',
    }
}

